import { motion } from "framer-motion";
import phoneMockup from "@/assets/phone-mockup.png";
import { Users, BadgeDollarSign } from "lucide-react";

const PhoneMockupSection = () => {
  return (
    <section className="py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* Text side */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">
              Invest Anytime, Anywhere
            </h2>
            <p className="mt-4 text-muted-foreground font-body text-lg">
              Our mobile-optimized platform gives you real-time charts, instant deposits, and full portfolio management at your fingertips.
            </p>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <div className="flex items-center gap-3 rounded-xl border border-gold-dark/30 bg-card px-5 py-4">
                <Users className="h-6 w-6 text-gold" />
                <div>
                  <p className="font-display text-lg font-bold text-foreground">500,000+</p>
                  <p className="text-xs text-muted-foreground font-body">Active Investors</p>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-xl border border-gold-dark/30 bg-card px-5 py-4">
                <BadgeDollarSign className="h-6 w-6 text-gold" />
                <div>
                  <p className="font-display text-lg font-bold text-foreground">Zero Fees</p>
                  <p className="text-xs text-muted-foreground font-body">On Deposits & Withdrawals</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Phone image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex justify-center"
          >
            <div className="relative">
              <div className="absolute -inset-4 rounded-full bg-gold/10 blur-3xl" />
              <img
                src={phoneMockup}
                alt="Prime Profits mobile investment interface showing charts and bitcoin prices"
                className="relative z-10 h-[500px] w-auto object-contain drop-shadow-[0_0_40px_hsl(var(--gold)/0.2)]"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PhoneMockupSection;
